<template lang="pug">
b-modal#addAnnouncementBanner(
  ref="addAnnouncementBanner"
  :title="$t('ui.combine.add_announcement_banner')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row.mb-3
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.banner_type')").mb-0
          b-form-select(
            :dirty="$v.banner_type.$dirty"
            :error="$v.banner_type.$error"
            v-model.trim.lazy="$v.banner_type.$model"
            :disabled="loading"
            size="sm"
          )
            option(value="" disabled) {{ $t('message.select_option') }}
            option(value=1) {{ $t('ui.before_login') }}
            option(value=2) {{ $t('ui.after_login') }}
          ValidateResult(:value="$v.banner_type" :name="$t('ui.banner_type')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.target')").mb-0
          b-form-select(
            :dirty="$v.target_window.$dirty"
            :error="$v.target_window.$error"
            v-model.trim.lazy="$v.target_window.$model"
            :disabled="loading"
            size="sm"
          )
            option(value="" disabled) {{ $t('message.select_option') }}
            option(value="_blank") {{ $t('ui.new_window_tab') }}
            option(value="_self") {{ $t('ui.current_page') }}
          ValidateResult(:value="$v.target_window" :name="$t('ui.target')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.btn_href')").mb-2
          DebounceInput(
            size="sm"
            ref="btn_href"
            type="text"
            :dirty="$v.btn_href.$dirty"
            :error="$v.btn_href.$error"
            v-model.trim.lazy="$v.btn_href.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.btn_href" :name="$t('ui.btn_href')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.default_order')").mb-2
          div.d-flex
            label.custom-switch
              input.custom-switch-input(
                type="checkbox"
                required
                :dirty="$v.default_order.$dirty"
                :error="$v.default_order.$error"
                v-model.trim.lazy="$v.default_order.$model"
                :disabled="loading"
              )
              span.custom-switch-indicator          
          ValidateResult(:value="$v.default_order" :name="$t('ui.default_order')")
      div.col-sm-12.col-md-4.col-lg-4(v-if="default_order == false")
        b-form-group(:label="$t('ui.item_order')").mb-0
          CMSBannerCount(
            :operatorID="operatorID"
            ref="item_order"
            size="sm"
            required
            type="array"
            :dirty="$v.item_order.$dirty"
            :error="$v.item_order.$error"
            v-model.trim.lazy="$v.item_order.$model"
            bType="announcement"
            :disabled="loading"
            :viewType="viewType"
          )
          ValidateResult(:value="$v.item_order" :name="$t('ui.item_order')")
    .row
      .col-12 
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#enAnnAdd-tab.nav-link(data-toggle='tab' href='#enAnnAdd-content' role='tab' aria-controls='enAnnAdd' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cnAnnAdd-tab.nav-link(data-toggle='tab' href='#cnAnnAdd-content' role='tab' aria-controls='cnAnnAdd' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#localAnnAdd-tab.nav-link(data-toggle='tab' href='#localAnnAdd-content' role='tab' aria-controls='localAnnAdd' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}

        #editorcontent.tab-content.tab-bordered
          #enAnnAdd-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='enAnnAdd-tab')
            .d-flex.flex-wrap
              b-form-group.w-100.mb-0
                label {{ $t('ui.title') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_title')")
                ckeditor(
                  v-model="en_title"
                  :config="enTitleConfig"
                  :disabled="loading"
                )
              b-form-group.w-100.mb-0
                label {{ $t('ui.body') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_body')")
                ckeditor(
                  v-model="en_body"
                  :config="enBodyConfig"
                  :disabled="loading"
                  @ready="onEditorReady"
                  @namespaceloaded="onNamespaceLoaded"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][0] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.en_image.$dirty"
                  :error="$v.en_image.$error"
                  v-model.trim.lazy="$v.en_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectEn"
                  v-if="enImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.en_image" :name="$t('ui.en_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeEnImage()"
                  variant="danger"
                  size="sm"
                  v-if="enImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enImageSrc != null" :src="enImageSrc")                
              //- b-form-group.w-100(:label="$t('ui.btn_text')").mb-0
              //-   DebounceInput(
              //-     size="sm"
              //-     ref="en_btn"
              //-     type="text"
              //-     :dirty="$v.en_btn.$dirty"
              //-     :error="$v.en_btn.$error"
              //-     v-model.trim.lazy="$v.en_btn.$model"
              //-     :disabled="loading"
              //-   )
              //-   ValidateResult(:value="$v.en_btn" :name="$t('ui.en_btn')")

          #cnAnnAdd-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cnAnnAdd-tab')
            .d-flex.flex-wrap
              b-form-group.w-100.mb-0
                label {{ $t('ui.title') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_title')")
                ckeditor(
                  v-model="cn_title"
                  :config="cnTitleConfig"
                  :disabled="loading"
                )
              b-form-group.w-100.mb-0
                label {{ $t('ui.body') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_body')")
                ckeditor(
                  v-model="cn_body"
                  :config="cnBodyConfig"
                  :disabled="loading"
                  @ready="onEditorReady"
                  @namespaceloaded="onNamespaceLoaded"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][0] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.cn_image.$dirty"
                  :error="$v.cn_image.$error"
                  v-model.trim.lazy="$v.cn_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectCn"
                  v-if="cnImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.en_image" :name="$t('ui.cn_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeCnImage()"
                  variant="danger"
                  size="sm"
                  v-if="cnImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enImageSrc != null" :src="cnImageSrc")                
              //- b-form-group.w-100(:label="$t('ui.btn_text')").mb-0
              //-   DebounceInput(
              //-     size="sm"
              //-     ref="cn_btn"
              //-     type="text"
              //-     :dirty="$v.cn_btn.$dirty"
              //-     :error="$v.cn_btn.$error"
              //-     v-model.trim.lazy="$v.cn_btn.$model"
              //-     :disabled="loading"
              //-   )
              //-   ValidateResult(:value="$v.cn_btn" :name="$t('ui.cn_btn')")

          #localAnnAdd-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='localAnnAdd-tab')
            .d-flex.flex-wrap
              b-form-group.w-100.mb-0
                label {{ $t('ui.title') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_title')")
                ckeditor(
                  v-model="local_title"
                  :config="localTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100.mb-0
                label {{ $t('ui.body') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_cms_announcement_body')")
                ckeditor(
                  v-model="local_body"
                  :config="localBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][0] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.local_image.$dirty"
                  :error="$v.local_image.$error"
                  v-model.trim.lazy="$v.local_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectLocal"
                  v-if="localImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}               
                ValidateResult(:value="$v.local_image" :name="$t('ui.local_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeLocalImage()"
                  variant="danger"
                  size="sm"
                  v-if="localImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="localImageSrc != null" :src="localImageSrc")
              //- b-form-group.w-100(:label="$t('ui.btn_text')").mb-0
              //-   DebounceInput(
              //-     size="sm"
              //-     ref="local_btn"
              //-     type="text"
              //-     :dirty="$v.local_btn.$dirty"
              //-     :error="$v.local_btn.$error"
              //-     v-model.trim.lazy="$v.local_btn.$model"
              //-     :disabled="loading"
              //-   )
              //-   ValidateResult(:value="$v.local_btn" :name="$t('ui.local_btn')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor
  },
  props: {
    // item: {
    //   type: Object
    // },
    // imgSize: {
    //   type: Array,
    //   default: null
    // }
    viewType: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      banner_type: "",
      item_order: 0,
      default_order: true,
      en_title: "",
      en_body: "",
      en_image: null,
      cn_title: "",
      cn_body: "",
      cn_image: null,
      local_title: "",
      local_body: "",
      local_image: null,
      localTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      enTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      localBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      enBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      file: "",
      en_background_url: "",
      cn_background_url: "",
      local_background_url: "",
      enImageName: "",
      cnImageName: "",
      localImageName: "",
      enImageSrc: null,
      cnImageSrc: null,
      localImageSrc: null,
      target_window: "",
      en_btn: "",
      cn_btn: "",
      local_btn: "",
      btn_href: "",
      activeTab: "en"
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    banner_type: {
      required
    },
    default_order: {
      required
    },
    item_order: {
      required : requiredIf(function () {
        return this.default_order == false;
      }),
      minValue(value) {
        if (this.default_order == true) {
          return minValue(0)(value)
        } else {
          return minValue(1)(value)
        }
      }
    },
    en_image: {
      required : requiredIf(function () {
        return this.enImageSrc == null;
      }),
      fileSizeValidation
    },
    cn_image: {
      fileSizeValidation
    },
    local_image: {
      fileSizeValidation
    },
    target_window: {
      required
    },
    btn_href: {
      maxLength: maxLength(500)
    },
    // en_btn: {
    //   maxLength: maxLength(255)
    // },
    // cn_btn: {
    //   maxLength: maxLength(255)
    // },
    // local_btn: {
    //   maxLength: maxLength(255)
    // }
  },
  watch: {
    en_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enImageSrc = value;
            })
            .catch(() => {
              this.enImageSrc = null;
            });
        } else {
          this.enImageSrc = null;
        }
      }
    },
    cn_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.cnImageSrc = value;
            })
            .catch(() => {
              this.cnImageSrc = null;
            });
        } else {
          this.cnImageSrc = null;
        }
      }
    },
    local_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.localImageSrc = value;
            })
            .catch(() => {
              this.localImageSrc = null;
            });
        } else {
          this.localImageSrc = null;
        }
      }
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    onNamespaceLoaded( CKEDITOR ) {
      // CKEDITOR.plugins.addExternal( 'editorplaceholder', 'https://raw.githack.com/ckeditor/ckeditor4/major/plugins/editorplaceholder/plugin.js' );
    },
    onEditorReady(ev) {
      // console.log(ev.dataProcessor.writer)

      // var blockTags = ['div','h1','h2','h3','h4','h5','h6','p','pre','li','blockquote','ul','ol',
      //   'table','thead','tbody','tfoot','td','th',];

      // for (var i = 0; i < blockTags.length; i++)
      // {
      //   ev.dataProcessor.writer.setRules( blockTags[i], {
      //     indent : false,
      //     breakBeforeOpen : false,
      //     breakAfterOpen : false,
      //     breakBeforeClose : false,
      //     breakAfterClose : false
      //   });
      // }
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeEnImage() {
      this.en_image = null;
      this.en_background_url = "";
      this.enImageName = "";
      this.enImageSrc = null;
    },
    removeCnImage() {
      this.cn_image = null;
      this.cn_background_url = "";
      this.cnImageName = "";
      this.cnImageSrc = null;
    },
    removeLocalImage() {
      this.local_image = null;
      this.local_background_url = "";
      this.localImageName = "";
      this.localImageSrc = null;
    },
    onSelectEn(evt) {
      if(evt.target.files.length > 0){
        this.enImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectCn(evt) {
      if(evt.target.files.length > 0){
        this.cnImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectLocal(evt) {
      if(evt.target.files.length > 0){
        this.localImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.cmsAnnouncementBannerAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        en_title: this.en_title,
        en_body: this.en_body,
        en_background_url: this.en_background_url,
        cn_title: this.cn_title,
        cn_body: this.cn_body,
        cn_background_url: this.cn_background_url,
        local_title: this.local_title,
        local_body: this.local_body,
        local_background_url: this.local_background_url,
        default_order: this.default_order,
        item_order: this.default_order == false ? this.item_order : null,
        banner_type: this.banner_type,
        target_window: this.target_window,
        en_btn: this.en_btn,
        cn_btn: this.cn_btn,
        local_btn: this.local_btn,
        btn_href: this.btn_href,
        view_type: this.viewType
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addAnnouncementBanner.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_announcement_banner", this.feedback.status);
                this.$refs.addAnnouncementBanner.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadEnImage() {
      if (this.enImageName == "") return;

      const formData = new FormData();
      formData.append("file", this.en_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.en_background_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadCnImage() {
      if (this.cnImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.cn_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.cn_background_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadLocalImage() {
      if (this.localImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.local_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.local_background_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadEnImage();
      const p2 = this.uploadCnImage();
      const p3 = this.uploadLocalImage();
      const someResult = await p1;
      const anotherResult = await p2;
      const anotherResult2 = await p3;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.banner_type = "";
      this.default_order = true;
      this.item_order = 0;
      this.en_title = "";
      this.en_body = "";
      this.en_image = null;
      this.cn_title = "";
      this.cn_body = "";
      this.cn_image = null;
      this.local_title = "";
      this.local_body = "";
      this.local_image = null;
      this.btn_href = ''
      this.en_btn = ''
      this.cn_btn = ''
      this.local_btn = ''
      this.enImageName = "";
      this.cnImageName = "";
      this.localImageName = "";
      this.en_background_url = ""
      this.cn_background_url = ""
      this.local_background_url = ""
      this.target_window = ""
      this.$v.$reset();
      $("#addAnnouncementBanner").find('.modal-content').first().removeAttr('tabindex');
    },
    // Enhanced CKEditor security setup method
    setupEditorSecurity(editor) {
      // Block paste files/base64 images
      editor.on('paste', function (e) {
        if (e.data && e.data.dataTransfer && typeof e.data.dataTransfer.getFiles === 'function') {
          const files = e.data.dataTransfer.getFiles();
          if (files && files.length > 0) {
            e.cancel();
            return;
          }
        }
        if (e.data && e.data.dataValue && e.data.dataValue.indexOf('data:image') !== -1) {
          e.cancel();
        }
      });

      // Block drag & drop files/images
      editor.on('contentDom', function () {
        editor.document.on('drop', function (e) {
          const dataTransfer = e.data.$.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.data.preventDefault(true);
          }
        });
      });

      // Additional security measures
      editor.on('beforeCommandExec', function (evt) {
        const command = evt.data.name;
        // Block potentially dangerous commands
        if (command === 'execCommand' || command === 'insertHtml') {
          // Add additional validation if needed
        }
      });

      if (editor._dialogSecurityHooked) return;
      editor._dialogSecurityHooked = true;

      // Hook dialog definition for upload button override
      editor.on('dialogDefinition', function (ev) {
        const dialogName = ev.data.name;
        const dialogDefinition = ev.data.definition;

        if (dialogName === 'image') {
          const uploadTab = dialogDefinition.getContents('Upload');
          const uploadButton = uploadTab.get('uploadButton');

          // Ensure upload input exists
          if (!uploadTab.get('upload')) {
            uploadTab.add({
              type: 'file',
              id: 'upload',
              label: 'Send it to the Server',
              size: 38,
            });
          }

          uploadButton['for'] = ['Upload', 'upload'];

          // Override upload button click
          uploadButton.onClick = function (evt) {
            const dialog = evt.sender.getDialog();
            const fileInput = dialog.getContentElement('Upload', 'upload').getInputElement().$;
            const file = fileInput.files[0];

            var invalidImage = this.$helpers.checkImgCkEditor(file);
            if (invalidImage)
              return;

            const formData = new FormData();
            formData.append('upload', file);

            fetch(editor.config.filebrowserUploadUrl, {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.uploaded === 1) {
                  dialog.getContentElement('info', 'txtUrl').setValue(data.url);
                  dialog.hide();
                } else {
                  const msg = (data.error && data.error.message) || 'Upload failed.';
                  alert(msg);
                  fileInput.value = '';
                }
              })
              .catch((err) => {
                alert('Upload error: ' + err.message);
                fileInput.value = '';
              });
          };
        }
      });

      // Attach validation after the dialog actually appears
      var vm = this;
      editor.on('dialogShow', function (evt) {
        const dialog = evt.data;
        if (dialog.getName() !== 'image') return;

        // Wait for DOM to render
        setTimeout(() => {
          const uploadElement = dialog.getContentElement('Upload', 'upload');
          if (!uploadElement) return;

          const input = uploadElement.getInputElement().$;

          // remove old listener (avoid duplicates)
          input.removeEventListener('change', input._vueFileChangeHandler || (() => {}));

          // attach new listener
          input._vueFileChangeHandler = function () {
            const file = input.files[0];
            if (!file) return;

            var invalidImage = vm.$helpers.checkImgCkEditor(file);
            if (invalidImage) {
              input.value = '';
              return;
            }
          };

          input.addEventListener('change', input._vueFileChangeHandler);
        }, 100);
      });
    }
  }
};
</script>
